module.exports = {"development":{"host":"https://api.virtask.nl"},"production":{"host":"https://api.virtask.nl"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/api.json
// module id = 467
// module chunks = 0